import React from 'react'
// import { ReactQueryDevtools } from 'react-query-devtools'

// App Providers
import AppStoreProvider from 'core/providers/AppStoreProvider'
import AppReactQueryProvider from 'core/providers/AppReactQueryProvider'
import AppThemeProvider from 'core/providers/AppThemeProvider'
import AppMaterialUIThemeProvider from './core/providers/AppMaterialUIThemeProvider'
import AppKitProvider from './core/providers/AppKitProvider'

// App Routes
import AppRoutes from 'core/routing'

// App Global Styles
import GlobalStyle from 'common/config/theme/global'

function App() {
  return (
    <>
      <AppStoreProvider>
        <AppReactQueryProvider>
          <AppMaterialUIThemeProvider>
            <AppThemeProvider>
              <AppKitProvider>
                <AppRoutes />
              </AppKitProvider>
            </AppThemeProvider>
          </AppMaterialUIThemeProvider>
        </AppReactQueryProvider>
      </AppStoreProvider>
      <GlobalStyle />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </>
  )
}

export default App
